
namespace GeniuzPOS.PosShift {

    import fld = ReportRecvbyCashierbyDateRow.Fields;
    @Serenity.Decorators.registerClass()
    export class ReportRecvbyCashierbyDateGrid extends Serenity.EntityGrid<ReportRecvbyCashierbyDateRow, any> {
        protected getColumnsKey() { return ReportRecvbyCashierbyDateColumns.columnsKey; }
        // protected getDialogType() { return ReportRecvbyCashierbyDateDialog; }
        protected getIdProperty() { return ReportRecvbyCashierbyDateRow.idProperty; }
        protected getInsertPermission() { return ReportRecvbyCashierbyDateRow.insertPermission; }
        protected getLocalTextPrefix() { return ReportRecvbyCashierbyDateRow.localTextPrefix; }
        protected getService() { return ReportRecvbyCashierbyDateService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }

        protected getButtons() {
            var buttons = super.getButtons();

            // remove first button (Add button)
            buttons.splice(Q.indexOf(buttons, x => x.cssClass == "add-button"), 1);
            // buttons.splice(Q.indexOf(buttons, x => x.cssClass == 'column-picker-button'), 1)

            // Add buttons import excel, pdf
            buttons.push(Common.Helpers.ExcelExportHelper.createToolButton({
                grid: this,
                service: ReportRecvbyCashierbyDateService.baseUrl + '/ListExcel',
                onViewSubmit: () => this.onViewSubmit(),
                separator: true
            }));

            return buttons
        }

        protected createToolbarExtensions() {
            super.createToolbarExtensions();

            this.slickGrid.registerPlugin(new Slick.Data.GroupItemMetadataProvider());

            var groupingMixin = new Serenity.DraggableGroupingMixin({
                grid: this
            });

            // setting ShipCountry, ShipCity columns as initially grouped for this sample
            // you could add [GroupOrder(1)] to ShipCountry, and [GroupOrder(2)] to ShipCity
            // in OrderColumns.cs instead (recommended way)
            groupingMixin.plugin.setDroppedGroups(["CashierId"]);
            // groupingMixin.plugin.setDroppedGroups(["PluCode"]);


        }
        protected getSlickOptions() {
            var opt = super.getSlickOptions();
            // need to turn grouping panel ON for drag drop grouping to work properly
            opt.groupingPanel = true;
            return opt;
        }

        protected markupReady() {
            super.markupReady();

            // expanding all level 0 (Country) and level 1 (City) groups initially
            this.view.expandAllGroups(0);
            // this.view.expandAllGroups(1);
            // this.view.expandAllGroups(2);

        }

        protected getQuickFilters() {
            var filters = super.getQuickFilters();

            Q.first(filters, x => x.field == fld.CreateDate).init = w => {

                (w as Serenity.DateEditor).valueAsDate = new Date(Date.now());

                let endDate = w.element.nextAll(".s-DateEditor").getWidget(Serenity.DateEditor);
                endDate.valueAsDate = new Date(Date.now());
            };

           


            return filters;
        }
    }
}